import { gql } from "@apollo/client";
import { LanControllerInfo } from "./getLanControllersCall";


export const MAINTAIN_CONTROLLER_INFO = gql`
  mutation MaintainInfo($domain: String!, $newControllers: [CreateController!]!, $updatedControllers: [MaintainController!]!) {
    controller {
      maintainInfo(domain: $domain, newControllers: $newControllers, updatedControllers: $updatedControllers) {
        controller_id
        system_id
        name
        cpu_id
      }
    }
  }
`

export interface MaintainControllerResponse {
  controller: {
    maintainInfo: LanControllerInfo[]
  }
}

export interface UpdatedControllers {
  controller_id: number;
  cpu_id?: string;  
  system_id?: number;
  name?: string;
}

export type CreatePanelController = Omit<LanControllerInfo, "controller_id">; 

export interface MaintainControllerInfoParameters {
  domain?: string;
  newControllers: CreatePanelController[];
  updatedControllers: UpdatedControllers[];
}